export const faqs = [
  {
    id: "faq-1",
    question: "咖位观察局和普通的娱乐八卦账号有什么不同？",
    answer:
      "我们把讨论重点放在「位置关系」和「评价体系」上，而不是传播未经核实的私生活信息。每一篇对比都会先列出可观察的维度，再给判断，读者可以自己复核推理过程。",
  },
  {
    id: "faq-2",
    question: "你们判断「谁更火」的具体标准是什么？",
    answer:
      "我们使用热度、话题、商业、专业四个维度分别打分，并根据当期场景调整权重。不会把所有维度揉成一个总分，因为不同场景下各项的重要性本来就不一样。",
  },
  {
    id: "faq-3",
    question: "对比里的分数是怎么来的，可信吗？",
    answer:
      "分数是基于公开可观察的信号综合评估得出的相对值，用于横向比较，不代表绝对排名。我们会在文中标注统计口径与时间范围，也欢迎你根据自己的观察提出不同意见。",
  },
  {
    id: "faq-4",
    question: "网站上会指名讨论具体人物吗？",
    answer:
      "我们主要讨论行业现象与位置关系，通常以身份类型（例如头部主播、一线演员）来描述对比对象，避免针对个人的人身评价。涉及案例时会强调这是对现象的分析，而非对人的定论。",
  },
  {
    id: "faq-5",
    question: "内容多久更新一次？",
    answer:
      "正常情况下每周更新三篇深度解读，热度走势板块按月更新。遇到行业里出现较大的位置变动时，会临时增加解读篇目。",
  },
  {
    id: "faq-6",
    question: "可以投稿或者提供选题线索吗？",
    answer:
      "可以。我们欢迎来自品牌市场、内容创作、影视行业的从业者提供选题视角，也接受读者反馈。通过页面底部的订阅与反馈表单提交即可，我们会定期查看。",
  },
];